import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Camera.svg",
  "use": "Camera.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Camera.svg\"><path d=\"M10.0207,19.0208a2,2,0,0,1,0-4h8a2,2,0,0,1,0,4Zm14-4h28a4,4,0,0,1,4,4v26a4,4,0,0,1-4,4h-40a4,4,0,0,1-4-4v-22a2,2,0,0,1,2-2h10a2,2,0,0,0,2-2v-2A2,2,0,0,1,24.0207,15.0208Zm15,28a11,11,0,1,0-11-11A11,11,0,0,0,39.0209,43.0208Zm0-20a9,9,0,1,1-9,9A9,9,0,0,1,39.0209,23.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol